// extracted by mini-css-extract-plugin
export default {"additionalInfo":"additionalInfo_additionalInfo__i3O9A","additionalInfoList":"additionalInfo_additionalInfoList__Ynqb1"};